<template>
  <div :class="{active: isActive, pending: isStatusPending}" class="referral-earned-item">
    <div class="token">
      <token-pending v-if="isStatusPending" :type="type"></token-pending>
      <token-checked v-else-if="isActive" :type="type"></token-checked>
      <base-token v-else :type="type"></base-token>
    </div>

    <token-text
      :type="type"
      :text="value"
      :classes="'earned-sum paragraph-s paragraph-bold-heavy'">
    </token-text>
    <referral-status-badge :status="status"></referral-status-badge>
  </div>
</template>

<script>

import BaseToken from 'top20common/components/icons/tokens/BaseToken';
import TokenChecked from 'top20common/components/icons/tokens/TokenChecked';
import TokenPending from 'top20common/components/icons/tokens/TokenPending';

import ReferralStatusBadge from '@/common/badges/ReferralStatusBadge';
import TokenText from '@/common/token/TokenText';

export default {
  props: {
    type: {type: String},
    value: {type: String},
    status: {type: String},
    isActive: {type: Boolean, default: false}
  },
  computed: {
    isStatusPending() {
      return this.status === 'pending';
    }
  },
  components: {
    BaseToken,
    TokenChecked,
    TokenPending,
    TokenText,
    ReferralStatusBadge
  }
};
</script>

<style lang="scss" scoped>
.referral-earned-item {
  align-items: center;
  display: flex;
  flex-direction: column;

  .token {
    width: 35px;
    height: 35px;
    display: flex;
    flex-direction: column;
    align-items: center;
    /deep/ .base-token svg{
      top: 7px;
    }
  }

  .earned-sum {
    padding: 10px 0;
  }

  /deep/ .tag {
    margin-left: 0;
  }


  &:not(.active):not(.pending) {
    opacity: 0.5;
  }
  &.pending .earned-sum {
    opacity: 0.5;
  }
}
</style>
